<div
  class="w-fill-available flex flex-col gap-2"
  [attr.aria-disabled]="disabled()"
  [class.opacity-60]="disabled()"
  [class.pointer-events-none]="disabled()"
>
  <h3 class="text-base">{{ 'pages.campaignDetails.filter.scope' | translate }}</h3>

  <div class="flex items-center gap-4 w-fill-available">
    @if (dateFilterReady()) {
      <app-profile-date-filter
        class="w-[252px]"
        [campaignAnalytics]="campaignAnalytics()"
        [initialState]="dateFilterState()"
        [loading]="loading()"
        [allowedDateRange]="allowedDateRange()"
        (dateRangeChanged)="onDateRangeChanged($event)"
        (selectedRangeChanged)="onSelectedRangeChanged($event)"
      />
    } @else {
      <ngx-skeleton-loader
        class="w-[252px] h-[34px]"
        [theme]="{ height: '34px', width: '252px', 'border-radius': '100vw' }"
      />
    }

    <app-profile-platform-feature-select
      class="w-[252px]"
      [campaignAnalytics]="campaignAnalytics()"
      [initialSelectedPlatformFeatures]="campaignAnalyticsFilter().platformFeatures"
      [loading]="loading()"
      (panelClosed)="onPlatformFeaturesPanelClosed()"
      (platformFeaturesChanged)="onPlatformFeaturesChanged($event)"
    />

    @if (!creatorBriefingMode()) {
      <app-profile-general-filters
        class="w-[252px]"
        [campaignAnalytics]="campaignAnalytics()"
        [initialSelectedCreatorIds]="campaignAnalyticsFilter().creatorIds"
        [loading]="loading()"
        (panelClosed)="onCreatorIdsPanelClosed()"
        (creatorIdsChanged)="onCreatorIdsChanged($event)"
      />
    }
  </div>
</div>
